import { t } from '../locale'
import { ZefixDetailsPdf, ZefixSearchResult } from '../types/zefix.type'

export function statusVariant(status: ZefixSearchResult['status']): string {
  if (status === 'ACTIVE') return 'success'
  if (status === 'CANCELLED') return 'danger'
  return 'warning'
}

export function statusLabel(status: ZefixSearchResult['status']): string {
  if (status === 'ACTIVE') return t('zefixStatusActive')
  if (status === 'CANCELLED') return t('zefixStatusCancelled')
  if (status === 'BEING_CANCELLED') return t('zefixStatusBeingCancelled')
  return '-'
}

export function statusLabelPdf(status: ZefixDetailsPdf['status']): string {
  if (status === 'ACTIVE') return t('zefixStatusActive')
  if (status === 'CANCELLED') return t('zefixStatusCancelled')
  if (status === 'BEING_CANCELLED') return t('zefixStatusBeingCancelled')
  return '-'
}

export function stripSogcMarkup(text: string): string {
  return text.replace(/<FT[^>]*>(.*?)<\/FT>/gs, '$1').trim()
}

export function formatAddress(addr: ZefixDetailsPdf['address']): string {
  if (!addr) return ''
  const parts = [
    addr.careOf,
    addr.organisation,
    addr.addon,
    [addr.street, addr.houseNumber].filter(Boolean).join(' '),
    addr.poBox,
    [addr.swissZipCode, addr.city].filter(Boolean).join(' '),
  ]
  return parts.filter(Boolean).join(', ')
}
